import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { BsnSeal } from "@/components/BsnSeal";
import { STATEMENTS } from "@/pages/About";
import { STORE_VISIBLE } from "@/lib/flags";

const EmbossedCard = ({ s }) => (
  <div className="emboss-card rounded-2xl p-8 sm:p-10 h-full" data-testid={`mission-card-${s.label.replace(/[^a-zA-Z]/g, "").toLowerCase()}`}>
    <div className="flex items-center gap-4 mb-5">
      <div className="emboss-medallion w-14 h-14 rounded-full flex items-center justify-center shrink-0">
        <s.icon className="w-6 h-6 text-bsn-midnight" />
      </div>
      <h2 className="emboss-title font-serif text-2xl sm:text-3xl font-semibold">{s.label}</h2>
    </div>
    <div className="emboss-rule mb-5" />
    <p className="text-bsn-ice/90 text-lg leading-relaxed font-serif">{s.text}</p>
  </div>
);

export default function Mission() {
  return (
    <div className="bg-bsn-midnight min-h-screen" data-testid="mission-page">
      <section className="max-w-6xl mx-auto px-4 pt-16 pb-10 sm:pt-20 text-center">
        <div className="flex justify-center mb-6"><BsnSeal size={88} /></div>
        <p className="eyebrow text-bsn-gold">Bright Stories Network</p>
        <h1 className="emboss-title font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold mt-3">Mission &amp; Vision</h1>
        <p className="mt-5 text-bsn-ice/75 text-base md:text-lg max-w-2xl mx-auto">
          The guiding statements behind every story, resource, and gift we share.
        </p>
      </section>

      <section className="max-w-6xl mx-auto px-4 pb-20">
        <div className="grid md:grid-cols-2 gap-8" data-testid="mission-statements">
          {STATEMENTS.map((s) => <EmbossedCard key={s.label} s={s} />)}
        </div>
        {STORE_VISIBLE && <div className="text-center mt-14">
          <Link to="/donations" className="inline-flex items-center gap-2 px-7 py-3 rounded-full btn-gold font-semibold" data-testid="mission-donate-btn">
            <Heart className="w-5 h-5" /> Support the Mission
          </Link>
        </div>}
      </section>
    </div>
  );
}
